import React, { Component } from "react";
import axios from "axios";
import { baseApiUrl } from  "../axios_setup";
import { runInThisContext } from "vm";

class DominosFranchiseeDropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            franchiseesLoaded: false,
            storesLoaded: false,
            franchisees: [],
            stores: []
        };
    }

    componentDidMount() {
        axios.get(
            `/organizations/${gon.organization_id}/api/v1/storeinfo/franchisees`
        ).then(res => {
            const franchisees = res.data;
            this.setState({
                franchiseesLoaded: true,
                franchisees: franchisees
            });
        });
    }

    handleFranchiseeChange(event) {
        event.preventDefault();
        this.props.onChange(event);

        const franchisee_id = event.target.value;
        axios.get(
            `/organizations/${gon.organization_id}/api/v1/storeinfo/stores/${franchisee_id}`
        ).then(res => {
            this.props.loadStores(res.data);
        })
    }

    render() {
        var custom_field = this.props.customField;
        var loading = <div>loading...</div>
        var franchiseeSelect;

        if (this.state.franchiseesLoaded) {
            franchiseeSelect = <select name="franchisee"
                                       id="franchisee"
                                       className="form-control pl-0 dyn-field-border-color dyn-field-label-color"
                                       required={custom_field.required}
                                       onChange={(event) => this.handleFranchiseeChange(event)}
                               >
                                   <option value="">Select a franchisee...</option>

                                   {this.state.franchisees.map(option => {
                                       return <option value={option.id} key={option.id}>{option.name}</option>
                                   })}
                               </select>
        } else {
            franchiseeSelect = loading;
        }

        return <div>
                   <div className={custom_field.error ? "form-group invalid-field mb-5" : "form-group mb-5"} key="franchisee" style={{ display: custom_field.visible ? 'block' : 'none' }}>
                       <label htmlFor="franchisee" id="franchisee-label"
                              className="mb-0 wrapped-label-one-line dyn-field-label-color">{custom_field.required && '*'} Franchisee</label>

                       <div className="select-dropdown">
                           {franchiseeSelect}
                           <i className="fa fa-angle-down dyn-field-label-color"></i>
                       </div>
                   </div>
               </div>
    }
}

export default DominosFranchiseeDropdown